export const apiName: string = 'cercas-projetos';
export const cercaRoute: string = 'cercas';
export const cercaStorage: string = 'cercas';
export const cercaModuleName: any = {plural: 'Cercas', single: 'Cerca'};

export const cercaQuery: any = {
    "where":{
        "ativo":true,
        "nome":{"regexp":"/REPLACEHERE/i"}
    },
    "order":"nome"
};

export const tiposCercas: any[] = [
    {Key: 1, Value: "circular"},
    {Key: 2, Value: "poligonal"}
];


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/rastreamentos/cercas/shared/data.service.ts
 **/